document.addEventListener('DOMContentLoaded', function (_event) {
  if (window.location.pathname.indexOf('/payment-methods/card') >= 0 && window.location.hash.indexOf('ab=true') >= 0) {
    // Hide Header
    for (const elem of document.querySelectorAll('nav')) {
      elem.remove();
    }

    // Hide sections
    for (const section of document.querySelectorAll('section')) {
      if (!section.classList.contains('table-section')) {
        section.style.display = 'none';
      }
    }

    // Hide footer
    for (const footer of document.querySelectorAll('footer')) {
      footer.style.display = 'none';
    }

    const currentLocale = window.location.href.split('/')[3].substring(0, 2);
    // Solo plan value by default
    const redirection = 'pricing';

    let redirectionParam = '?select-toggle=solo';
    if (window.location.hash.indexOf('plan=team') >= 0) {
      redirectionParam = '?select-toggle=team';
    } else if (window.location.hash.indexOf('plan=creation') >= 0) {
      redirectionParam = '?select-toggle=creation';
    }

    let anchor = '#desktop-table-header-anchor';
    if (window.matchMedia('(max-width: 767px)').matches) {
      anchor = '#mobile-table-header-anchor';
    }

    // Add the X to close the modale.
    document.querySelectorAll('.table-section .x-container')[0].insertAdjacentHTML('beforeBegin',
      `<div class='-mt-10'>\
        <div class='pl-20 pr-20 w-auto m-auto relative mb-12 md:mb-0 z-150' style='max-width: 1200px'>\
          <a href='/${currentLocale}/${redirection}${redirectionParam}${anchor}'>\
            <svg width='40' height='40' viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg' class='ml-auto cursor-pointer mr-12 md:mr-0' style='max-width:30px; max-height:30px'>\
              <path fill-rule='evenodd' clip-rule='evenodd' d='M6.08398 27.7565L9.17758 30.8501L18.4583 21.5693L27.7391 30.8501L30.8327 27.7565L21.5519 18.4757L30.8327 9.19491L27.7391 6.10132L18.4583 15.3821L9.17758 6.10136L6.08399 9.19495L15.3647 18.4757L6.08398 27.7565Z' fill='#1D1D1B'/>\
            </svg>\
          </a>\
        </div>\
      </div>`
    );
  }
});
